<template>
	<picture class="h-100 w-100 position-absolute d-flex align-items-center overflow-hidden">
		<source v-if="image.large.url" media="(min-width: 768px)" :srcset="image.large.url" type="image/jpeg" />
		<source v-if="image.medium.url" media="(max-width: 768px)" :srcset="image.medium.url" type="image/jpeg" />
		<img :src="image.full.url" :class="imgClass" :width="image.full.width" :height="image.full.height" :alt="alt" loading="lazy">
	</picture>
</template>

<script>
export default {
	props: {
		image: {
			required: true,
			type: Object,
		},
		alt: {
			required: true,
			type: String,
		},
		classes: {
			required: false,
			type: Array,
		},
	},
	computed: {
		imgClass() {
			let c = [''];
			if (this.classes) {
				c = c.concat(this.classes)
			}
			return c
		}
	}
}
</script>
